import React, { useState, useEffect } from 'react';
import './captcha.css'

const ContactFormWithCaptcha = () => {
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  
  // CAPTCHA state
  const [captchaText, setCaptchaText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [error, setError] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  // Generate random CAPTCHA text
  const generateCaptcha = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInput('');
    setIsVerified(false);
  };

  // Initialize CAPTCHA on component mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle CAPTCHA verification
  const verifyCaptcha = () => {
    if (userInput === captchaText) {
      setIsVerified(true);
      setError('');
      return true;
    } else {
      setError('CAPTCHA text does not match. Please try again.');
      generateCaptcha();
      setIsVerified(false);
      return false;
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!verifyCaptcha()) {
      return;
    }

    // Form is valid and CAPTCHA verified
    alert(`Form submitted successfully!\nName: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      message: ''
    });
    generateCaptcha();
  };

  return (
    <div className="contact-form-container">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <div className="captcha-group">
          <div className="captcha-display">
            <label>CAPTCHA:</label>
            <div className="captcha-text">{captchaText}</div>
            <button 
              type="button" 
              onClick={generateCaptcha}
              className="refresh-btn"
              aria-label="Refresh CAPTCHA"
            >
              ↻
            </button>

            <input
            type="text"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="Type the text above"
            required
          />
          
          {error && <div className="error-message">{error}</div>}
            <button 
          type="submit" 
          disabled={!isVerified}
          className="submit-btn"
        >
          Submit
        </button>
          </div>
          
          
        </div>

        
      </form>
    </div>
  );
};

export default ContactFormWithCaptcha;